<template>
  <div>Email Marketing Dashboard</div>
</template>
<script>
export default {
  name: 'email_marketing_dashboard',
  components: {},
  data() {
    return {}
  },
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  watch: {},
  methods: {},
}
</script>
<style scoped lang="scss"></style>
<style lang="scss"></style>
